import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useApp } from '../context/AppContext';

// A07 — Ring Connected. Account/integration connection state only.
const Settings = () => {
  const navigate = useNavigate();
  const { ring } = useApp();

  const connected = ring ? ring.connected : true;

  return (
    <div className="px-6 pt-2 pb-8 lp-enter">
      {/* Header */}
      <div className="relative flex items-center justify-center mb-8">
        <button
          onClick={() => navigate('/')}
          className="absolute left-0 flex items-center gap-1 lp-pressable"
          style={{ color: 'var(--lp-cream)' }}
        >
          <ChevronLeft size={20} />
          <span className="text-[16px]">Back</span>
        </button>
        <h1
          className="font-serif-lp text-[22px]"
          style={{ color: 'var(--lp-cream)' }}
        >
          Settings
        </h1>
      </div>

      <p className="section-label uppercase mb-3">Connected sources</p>

      <div className="lp-card-dark p-4 flex items-start justify-between gap-3">
        <div className="flex-1">
          <p
            className="text-[17px] font-semibold mb-1"
            style={{ color: 'var(--lp-cream)' }}
          >
            {ring ? ring.provider : 'Ring'}
          </p>
          <p
            className="text-[14px] leading-snug"
            style={{ color: 'var(--lp-body)' }}
          >
            {ring
              ? ring.description
              : 'Provides motion observations used as supporting evidence.'}
          </p>
        </div>
        <span
          className="text-[14px] flex-shrink-0 pt-1"
          style={{ color: connected ? 'var(--lp-sage)' : 'var(--lp-muted)' }}
        >
          {connected ? 'Connected' : 'Not connected'}
        </span>
      </div>
    </div>
  );
};

export default Settings;
